import angular from "angular";

let NewVideoController = function (
  $filter,
  $mdDialog,
  $scope,
  $state,
  $timeout,
  Video,
  State,
  City,
  Toast
) {
  let $ctrl = this;
  angular.extend($ctrl, {
    save,
    onChangeState,
  });

  $ctrl.id = $state.params.id;
  $ctrl.states = [];
  $ctrl.cities = [];

  $ctrl.data = {
    description: "",
    status: false,
    open_in_webview: false,
    banner_url: "",
    url: "",
    type: "",
    state_id: [],
    city_id: [],
  };

  function loadResource(id) {
    State.index({ limit: 10000000000 })
      .then((result) => {
        $ctrl.states = result;
        if (id) {
          Video.getVideo(id)
            .then((response) => {
              $ctrl.data.id = response.id;
              $ctrl.data.description = response.description;
              $ctrl.data.status = response.status;
              $ctrl.data.open_in_webview = Boolean(response.open_in_webview);
              $ctrl.data.type = response.type;
              $ctrl.data.banner_url = response.banner_url;
              $ctrl.data.url = response.url;
              if(response.regions.length) {
                const result = getStateCities(response.regions);
                $ctrl.data.state_id = angular.copy(result.states);
                $ctrl.data.city_id = angular.copy(result.cities);
              }
              else{
                $ctrl.data.state_id = [null];
                $ctrl.data.city_id = [null];
              }
              onChangeState();
            })
            .catch((err) => {
              $ctrl.uiState = "ERROR";
            });
        }
      })
      .catch((err) => {
        console.log("err:", err);
        $ctrl.uiState = "ERROR";
      });
  }

  function getStateCities(regions) {
    const cities = [];
    const states = [];
    regions.forEach((state) => {
      states.push(state.id.toString());
      state.regions.forEach((region) => {
        cities.push(region.id.toString());
      });
    });

    return {
      cities,
      states,
    };
  }

  function onChangeState(stateIdArr, clearCities = false) {
    if ($ctrl.data.state_id.length !== 0) {
      const lastPosition = $ctrl.data.state_id.length - 1;
      if (
        $ctrl.data.state_id.includes(null) &&
        $ctrl.data.state_id[lastPosition] === null &&
        lastPosition !== 0
      ) {
        $ctrl.data.state_id = [null];
        if (clearCities) $ctrl.data.city_id = [null];
        return;
      } else if (
        $ctrl.data.state_id[0] === null &&
        $ctrl.data.state_id.length > 1
      ) {
        $ctrl.data.state_id.split(0, 1);
      }

      City.index({
        state_id: $ctrl.data.state_id,
        limit: 1000000,
      })
        .then((cities) => {
          $ctrl.cities = cities;
        })
        .catch((err) => {
          console.log("err:", err);
          $ctrl.loadingCities = false;
        })
        .finally(() => {
          angular
            .element(document.querySelector(".input-search-city"))
            .on("keydown", function (ev) {
              ev.stopPropagation();
            });
        });
    }

    if (clearCities) {
      $ctrl.search = "";
      $ctrl.data.city_id = [];
      $ctrl.cities = [];
    }
  }

  $ctrl.getStateNames = function () {
    const map = $ctrl.data.state_id.map((_id) => {
      const idx = $ctrl.states.findIndex(
        ({ id }) => _id.toString() === id.toString()
      );
      if (idx > -1) return $ctrl.states[idx].name;
      else return "";
    });
    return map.join(", ");
  };

  $ctrl.getCitiesNames = function () {
    const map = $ctrl.data.city_id.map((_id) => {
      const idx = $ctrl.cities.findIndex(
        ({ id }) => _id.toString() === id.toString()
      );
      if (idx > -1) return $ctrl.cities[idx].name;
      else return "";
    });
    return map.join(", ");
  };

  function activate() {
    loadResource($ctrl.id);
  }

  function save() {
    const data = angular.copy($ctrl.data);
    if (data.state_id.includes(null)) {
      delete data.state_id;
    } else {
      data.state_id = data.state_id.map((item) => Number(item));
    }

    if (data.city_id.includes(null)) {
      delete data.city_id;
    } else {
      data.city_id = data.city_id.map((item) => Number(item));
    }

    Video.save(data)
      .then((response) => {
        $state.go("page.video-home");
      })
      .catch((err) => {
        Toast.error(err.data.message);
        $ctrl.uiState = "ERROR";
      });
  }

  activate();
};

NewVideoController.$inject = [
  "$filter",
  "$mdDialog",
  "$scope",
  "$state",
  "$timeout",
  "Video",
  "State",
  "City",
  "Toast",
];

export default NewVideoController;



// WEBPACK FOOTER //
// ./client/app/components/page/page-new-home-video.controller.js